export const SET_DATA = (state, { id, data, isPush }) => {
  if (isPush) {
    if (!state[id]) state[id] = [];
    state[id].push(data);
    return;
  }
  state[id] = data;
};

export const setFavorite = (state, isFave) => {
  state.courseDetail.favorite = isFave;
  // TODO reactive
};
export const clear = state => {
  state.lastCourse = [];
  state.courseDetail = {};
  state.goals = [];
  state.msgs = [];
  state.listCourse = [];
  state.someCatsListCourse = [];
  state.instractor = [];
};
export const clearSomeDetail = state => {
  state.courseDetail = {};
};
export const setCounts = (state, value) => {
  state.counts = value;
};



// WEBPACK FOOTER //
// ./src/store/modules/courses/mutations.js